// extracted by mini-css-extract-plugin
export default {"disclaimer":"reCaptchaDisclaimer_disclaimer"};